// Operator hover JS
if ($(window).width() > 767) {
    $('.termsLink').hover(
        function () {
            $(this).children('.hiddenTerms').addClass('active');
        },
        function () {
            $(this).children('.hiddenTerms').removeClass('active');
        }
    );

    $('.close').click(function () {
        $('.hiddenTerms').removeClass('active');
    });
} else {
    $('.termsLink').click(function () {
        $(this).children('.hiddenTerms').toggleClass('active');
    });

    $('.close').click(function (e) {
        $(this).parent().removeClass('active');
        e.stopPropagation();
    });
}

$(document).click(function (e) {
    if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
        if ($(e.target).hasClass("link-advertiser-tooltip")) {
            if ($(e.target).data("open-tooltip") === undefined || $(e.target).data("open-tooltip") == 'no' || $(".text-advertiser-tooltip", $(e.target)).css("visibility") == "hidden") {
                $(".text-advertiser-tooltip", $(e.target)).css("visibility", "visible")
                $(e.target).data("open-tooltip", "yes")
            } else {
                $(".text-advertiser-tooltip", $(e.target)).css("visibility", "hidden")
                $(e.target).data("open-tooltip", "no")
            }
        } else {
            $(".tac_ad_text .text-advertiser-tooltip").css("visibility", "hidden")
        }
    }
});

//Hide Standard Elements & Reveal A/B Test Elements
fireOpListABTest = function () {
    console.log('Running A/B test');
    $('#more-recommended-wrapper').addClass('d-none');
    $('#ab-view-more').removeClass('d-none');
    $('#ab-more-recommended-wrapper').removeClass('d-none');
    $(window).on('scroll', function () {
        if (
            $(window).scrollTop() <
            $('#ab-more-recommended-wrapper').offset().top - window.innerHeight
        ) {
            $('#back-to-top').removeClass('fixed');
        }
        if (
            $(window).scrollTop() >=
            $('#ab-more-recommended-wrapper').offset().top - window.innerHeight
        ) {
            $('#back-to-top').addClass('fixed');
        }
        if (
            $(window).scrollTop() >=
            $('#ab-more-recommended-wrapper').offset().top +
            $('#ab-more-recommended-wrapper').outerHeight() -
            window.innerHeight
        ) {
            $('#back-to-top').removeClass('fixed');
        }
    });
};

toggleAnchorFix = function (element) {
    $('html, body').animate(
        {
            scrollTop: $(element).offset().top,
        },
        500
    );
};

scrollToTop = function () {
    $('html, body').animate(
        {
            scrollTop: 0,
        },
        500
    );
};


/**
 * 6 Highest Paying Casino Op List AB Test
 * 3 functions to hide the number of li's shown on the small op list
 */
setGDCU1294Control = function () {
    console.log('Running A/B/C control');
    $('.operator-list-small li:gt(2)').addClass('d-none');
};
setGDCU1294BTest = function () {
    console.log('Running B Test');
    $('.operator-list-small li:lt(6)').removeClass('d-none');
};
setGDCU1294CTest = function () {
    console.log('Running C Test');
    $('.operator-list-small li:gt(2)').removeClass('d-none');
};

/**
 * Run this test in order to have NJ as the default state on US
 * Ticket: https://kaxmedia.atlassian.net/browse/GDCU-1326
 */
setGDCU1326BTest = function () {
    console.log('Running B Test');
    // Run rest if we dont have the test already set up & no state is selected by the user
    if (!$cookies.isKey('op_list_state')) {
        console.log('Firing B Test Trigger');
        $('body').trigger('vueOpList:abTest');
    }
};

window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
        document.getElementById('nav-hamburger').classList.remove('is-active');
    }
});


/**
 * Load More button scripts
 */

// if (typeof load_more_total_per_page === 'undefined') {
//     load_more_total_per_page = 10;
//     load_more_initial_visible_items = 20;
// }

// $(".show-more").off().click(function (event) {
//     oplistShowMore(event);
// }); 

// oplistShowMore = function (event) {
//     let total_page_items = 0
//     show_more_button = $(event.target);

//     if (!show_more_button.hasClass('show-more')) {
//         show_more_button = show_more_button.closest('.show-more');
//     }

//     show_less_button = show_more_button.parent().find(".show-less")
//     progress_bar = show_more_button.parent().find("progress")
//     progress_number = show_more_button.parent().find(".progress-number")
//     oplist_elements = show_more_button.parent().parent().find("li.operator-item-v2");
//     total_elements = oplist_elements.length;
//     oplist_elements.each(function (i) {
//         if ($(this).hasClass("d-none")) {
//             total_page_items++;
//             if (total_page_items > load_more_total_per_page) {
//                 return false;
//             } else {
//                 progress_bar.attr('value', i + 1);
//                 progress_number.html(i + 1)
//                 $(this).removeClass("d-none");
//                 show_less_button.show();
//             }
//         }
//         if (i >= (total_elements - 1)) {
//             show_more_button.hide();
//             return false;
//         }

//     });
// };

// $(".show-less").off().click(function (event) {
//     oplistShowless(event);
// }); 

// oplistShowless = function (event) {
//     let total_page_items = 0
//     show_less_button = $(event.target);

//     if (!show_less_button.hasClass('show-less')) {
//         show_less_button = show_less_button.closest('.show-less');
//     }

//     show_more_button = show_less_button.parent().find(".show-more")
//     progress_bar = show_less_button.parent().find("progress")
//     progress_number = show_less_button.parent().find(".progress-number")
//     oplist_elements = show_less_button.parent().parent().find("li.operator-item-v2").get().reverse();
//     total_elements = oplist_elements.length;

//     let scroll_position = 0;
//     $(oplist_elements).each(function (i) {
//         if (!$(this).hasClass("d-none")) {
//             scroll_position = $(this).position().top
//             total_page_items++;
//             $(this).addClass("d-none");
//             progress_bar.attr('value', total_elements - i - 1);
//             progress_number.html(total_elements - i - 1)
//             if (((total_elements - i - 1) % load_more_total_per_page) == 0) {
//                 if ((total_elements - i - 1) <= load_more_initial_visible_items) {
//                     show_less_button.hide()
//                     show_more_button.show();
//                     scroll_position = scroll_position - 350
//                 }
//                 return false;
//             } else {
//                 show_more_button.show();
//             }
//         }
//         if ((total_elements - i) <= load_more_initial_visible_items + 1) {
//             show_less_button.hide();
//             return false;
//         }
//     });
//     $("html, body").animate({scrollTop: scroll_position}, "fast");
// }; 
